<div class="bg-workspace min-vh-100">
  <top-bar [title]="'Dashboard'"></top-bar>
  <div class="container py-4 px-md-5">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">Home</li>
      </ol>
    </nav>
    <div class="card">
      <div class="card-header row">
        <div class="col-12 col-md-7 mb-3 mb-md-0">
          <div class="position-relative d-flex h-100">
            <input
              name="search-term"
              type="text"
              class="form-control pe-5 py-3"
              [(ngModel)]="searchTerm"
              (ngModelChange)="searchUpdated()"
              placeholder="Search"
            />
            <button
              type="submit"
              class="btn position-absolute end-0 top-0 bottom-0"
            >
              <app-icon name="search" class="icon-primary"></app-icon>
            </button>
          </div>
        </div>
        <div class="col-9 col-md-4">
          <div class="form-floating">
            <select
              id="one-search-type"
              class="form-select"
              name="one-search-type"
              [(ngModel)]="selectedType"
              (ngModelChange)="onTypeChanged()"
              [ngClass]="{ 'select-not-empty': selectedType }"
            >
              <option value="all">All types</option>
              <option [value]="oneSearchTypes.school">School</option>
              <option [value]="oneSearchTypes.person">Person</option>
              <option [value]="oneSearchTypes.student">Student</option>
              <option [value]="oneSearchTypes.teacher">Teacher</option>
              <option [value]="oneSearchTypes.manager">Manager</option>
              <option [value]="oneSearchTypes.group">Group</option>
            </select>
            <label for="one-search-type">Entity type</label>
          </div>
        </div>
        <div class="col-3 col-md-1 d-flex justify-content-end align-items-center">
          <button
            type="button"
            class="btn btn-primary rounded-circle px-2 d-inline-flex align-items-center justify-content-center"
            (click)="resetSearchForm()"
            aria-label="Reset search"
            title="Reset"
          >
            <app-icon name="refresh" class="icon-white"></app-icon>
          </button>
        </div>
      </div>
      <div class="card-body" *ngIf="searchTerm?.trim()?.length >= 3">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="mb-0">
            Results
            <span class="text-primary">( {{ searchedPage?.totalElements || 0 }} )</span>
          </h5>
        </div>

        <div class="table-responsive">
          <table class="table table-sm align-middle">
            <thead>
              <tr>
                <th>
                  <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="onSortChanged('type')">
                    Type{{ getSortMarker('type') }}
                  </button>
                </th>
                <th>
                  <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="onSortChanged('name')">
                    Name / ID{{ getSortMarker('name') }}
                  </button>
                </th>
                <th>
                  <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="onSortChanged('school')">
                    School{{ getSortMarker('school') }}
                  </button>
                </th>
                <th>
                  <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="onSortChanged('status')">
                    Status{{ getSortMarker('status') }}
                  </button>
                </th>
                <th>
                  <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="onSortChanged('context')">
                    Context{{ getSortMarker('context') }}
                  </button>
                </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr class="table-row cursor-pointer" *ngFor="let row of searchedRows; let i = index">
                <td class="ps-1 text-nowrap">
                  <span class="badge bg-primary">{{ row.typeLabel }}</span>
                </td>
                <td class="text-nowrap">
                  <div class="fw-bold" [innerHTML]="highlightText(row.name)"></div>
                  <small class="text-muted">ID: {{ row.id ?? '-' }}</small>
                </td>
                <td class="text-nowrap" [innerHTML]="highlightText(row.schoolName)"></td>
                <td class="text-nowrap">{{ row.status }}</td>
                <td class="text-nowrap" [innerHTML]="highlightText(row.context)"></td>
                <td class="text-nowrap">
                  <button
                    *ngIf="row.canOpen"
                    type="button"
                    class="btn btn-outline-secondary-2 btn-sm rounded-pill d-inline-flex"
                    (click)="openEntry(row.entry)"
                  >
                    Open
                    <app-icon name="angle-right" class="icon-primary ms-1"></app-icon>
                  </button>
                  <span *ngIf="!row.canOpen" class="text-muted">-</span>
                </td>
              </tr>
              <tr *ngIf="!searchedRows.length">
                <td colspan="6" class="text-center text-muted py-4">No results</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card-footer d-flex justify-content-end" *ngIf="searchTerm?.trim()?.length >= 3">
        <app-paginator
          [data]="searchedPage"
          [pageable]="pageablePeople"
          (newPage)="onPageChanged($event)"
        ></app-paginator>
      </div>
    </div>
  </div>
</div>
